import React, { useState } from "react";
import { Check, Palette } from "lucide-react";
import { THEMES, THEME_CATEGORIES, applyTheme, getCurrentTheme } from "@/lib/themes";

export default function ThemeSelector({ onThemeChange }) {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [currentTheme, setCurrentTheme] = useState(getCurrentTheme());

  const filteredThemes = selectedCategory === "All"
    ? THEMES
    : THEMES.filter(t => t.category === selectedCategory);

  const handleThemeSelect = (themeId) => {
    applyTheme(themeId);
    setCurrentTheme(themeId);
    if (onThemeChange) {
      onThemeChange(themeId);
    }
  };

  return (
    <div className="space-y-6">
      {/* Category Filter */}
      <div className="flex flex-wrap gap-2">
        {THEME_CATEGORIES.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className="px-4 py-2 rounded-lg border text-sm font-medium transition-colors"
            style={{
              borderColor: selectedCategory === category ? "var(--gio-primary)" : "var(--gio-border)",
              background: selectedCategory === category ? "var(--gio-primary-soft)" : "var(--gio-surface)",
              color: selectedCategory === category ? "var(--gio-primary)" : "var(--gio-muted)",
            }}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Theme Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {filteredThemes.map((theme) => (
          <ThemeCard
            key={theme.id}
            theme={theme}
            isSelected={currentTheme === theme.id}
            onSelect={() => handleThemeSelect(theme.id)}
          />
        ))}
      </div>
    </div>
  );
}

function ThemeCard({ theme, isSelected, onSelect }) {
  return (
    <button
      onClick={onSelect}
      className="relative p-4 rounded-xl border-2 transition hover:-translate-y-0.5"
      style={{
        borderColor: isSelected ? "var(--gio-primary)" : "var(--gio-border)",
        background: isSelected ? "var(--gio-primary-soft)" : "var(--gio-surface)",
        color: "var(--gio-text)",
      }}
    >
      {isSelected && (
        <div className="absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "var(--gio-primary)", color: "var(--gio-primary-contrast)" }}>
          <Check size={14} />
        </div>
      )}

      {/* Color Preview */}
      <div className="grid grid-cols-3 gap-1 mb-3 h-12">
        <div
          className="rounded"
          style={{ background: theme.colors["--gio-primary"] }}
        />
        <div
          className="rounded"
          style={{ background: theme.colors["--gio-surface"] }}
        />
        <div
          className="rounded"
          style={{ background: theme.colors["--gio-accent"] }}
        />
      </div>

      {/* Theme Info */}
      <div className="text-left">
        <h4 className="font-bold text-sm mb-1">{theme.name}</h4>
          <p className="text-xs" style={{ color: "var(--gio-muted)" }}>{theme.category}</p>
      </div>
    </button>
  );
}
